// Preserve complete upload URLs; prefix only legacy relative object paths.
module.exports = function formatNoneOssUrl(url, baseUrl) {
    if (!url) return '';
    if (/^(?:https?:)?\/\//i.test(url) || /^(?:data|blob):/i.test(url)) {
        return url;
    }
    if (!baseUrl) return url;
    return baseUrl.replace(/\/+$/, '') + '/' + url.replace(/^\/+/, '');
};



// WEBPACK FOOTER //
// ./fileUrl.js